import { render, staticRenderFns } from "./CategoryButton.vue?vue&type=template&id=3fb3d7d4"
import script from "./CategoryButton.vue?vue&type=script&lang=js"
export * from "./CategoryButton.vue?vue&type=script&lang=js"
import style0 from "./CategoryButton.vue?vue&type=style&index=0&id=3fb3d7d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports